<!-- 车皮调度计划 -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" :before-open="beforeOpen" @search-reset="searchReset" @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button size="small" icon="el-icon-download" :loading="templateLoading" @click="handleDownloadImportTemplate">导入模版下载</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{row, index}" slot="menu">
        <el-button v-if="canShowSendArrival(row)" type="text" size="small" :loading="sendLoadingId === row.id" :disabled="isSendArrivalDisabled(row)" @click="handleSendRailwayArrival(row)">发送到达通知</el-button>
        <el-button v-if="!isArrived(row)" type="text" size="small" @click="$refs.crud.rowEdit(row, index)">编辑</el-button>
        <el-button v-if="!isArrived(row)" type="text" size="small" @click="$refs.crud.rowDel(row, index)">删除</el-button>
      </template>
    </avue-crud>
    <dialog-reset height="65vh" top="5vh" width="80%" :title="formTitle" :visible.sync="formVisible">
      <form-component ref="formComponen" :transmitData="transmitData" @handleClose="handleClose"></form-component>
    </dialog-reset>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, remove, importExcel, exportExcel, downloadImportTemplate, sendRailwayArrival, getRailwayArrivalSendLock } from "./api";
import { searchTimeConfig, transitionTitle } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'
import FormComponent from './components/form-component.vue'

const padTime = value => {
  const text = String(value)
  return text.length < 2 ? `0${text}` : text
}
const formatDateTime = date => {
  const year = date.getFullYear()
  const month = padTime(date.getMonth() + 1)
  const day = padTime(date.getDate())
  const hour = padTime(date.getHours())
  const minute = padTime(date.getMinutes())
  const second = padTime(date.getSeconds())
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}
const getDefaultSearchDateRange = () => {
  const start = new Date()
  start.setDate(start.getDate() - 7)
  start.setHours(0, 0, 0, 0)
  const end = new Date()
  end.setDate(end.getDate() + 7)
  end.setHours(23, 59, 59, 999)
  return [formatDateTime(start), formatDateTime(end)]
}

export default {
  mixins: [crudMixins],
  components: { FormComponent },
  data () {
    const defaultSearchDateRange = getDefaultSearchDateRange()
    return {
      apiConfig: { getList, remove },
      exportLoading: false,
      templateLoading: false,
      sendLoadingId: null,
      sendLock: {
        locked: false,
        arrivalNoticeId: null,
      },
      defaultParams: {
        startTime: defaultSearchDateRange[0],
        endTime: defaultSearchDateRange[1],
      },
      formVisible: false,
      option: {
        ...this.$store.state.publicOption,
        addBtn: true,
        editBtn: false,
        viewBtn: true,
        delBtn: false,
        column: [
          {
            label: '计划号',
            prop: 'planNo',
            overHidden: true,
            width: 150,
          },
          {
            label: '车次编号',
            prop: 'trainNumber',
            search: true,
            overHidden: true,
            width: 150,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true,
            search: true,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            width: 150,
          },
          {
            label: '物资名称',
            prop: 'cargoName',
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'id'
            },
            width: 120,
          },
          {
            label: '车厢数',
            prop: 'carriageCount',
            search: true,
            overHidden: true,
            width: 100,
            type: 'number',
            min: 1,
            max: 99999,
          },
          {
            label: '计划量(吨)',
            prop: 'totalWeight',
            overHidden: true,
            width: 100,
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
          },
          {
            label: '预计到达时间',
            prop: 'trainArrivalTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
          },
          {
            label: '是否到达',
            prop: 'arrivalStatus',
            search: true,
            overHidden: true,
            type: 'select',
            dataType: 'string',
            dicData: this.$store.getters.commonDict['arrival_status'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '发送状态',
            prop: 'noticeSendStatus',
            overHidden: true,
            type: 'select',
            width: 120,
            dicData: [
              { label: '未发送', value: 0 },
              { label: '待匹配', value: 1 },
              { label: '已匹配', value: 2 },
            ],
          },
          {
            label: '发送时间',
            prop: 'noticeSendTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            overHidden: true,
            width: 150,
            type: 'select',
            props: {
              label: 'contractName',
              value: 'id'
            },
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            searchValue: defaultSearchDateRange,
          },
        ]
      },
    }
  },
  mounted () {
    this.refreshSendLock()
  },
  methods: {
    /** 是否到达：与字典 arrival_status 中「已到达」一致，一般为 1 */
    isArrived (row) {
      if (!row) return false
      const s = row.arrivalStatus
      return s === 1 || s === '1'
    },
    canShowSendArrival (row) {
      if (!row) return false
      const status = row.noticeSendStatus
      return !this.isArrived(row) && status !== 2 && status !== '2'
    },
    isSendArrivalDisabled (row) {
      if (!row || this.sendLoadingId) return true
      const status = row.noticeSendStatus
      if (status === 1 || status === '1') return true
      return this.sendLock && this.sendLock.locked && String(this.sendLock.arrivalNoticeId || '') !== String(row.id || '')
    },
    async refreshSendLock () {
      try {
        const res = await getRailwayArrivalSendLock()
        this.sendLock = (res && res.data && res.data.data) || (res && res.data) || { locked: false, arrivalNoticeId: null }
      } catch (e) {
        this.sendLock = { locked: false, arrivalNoticeId: null }
      }
    },
    async handleSendRailwayArrival (row) {
      if (!row || !row.id) return
      this.sendLoadingId = row.id
      try {
        const res = await sendRailwayArrival(row.id)
        const data = (res && res.data && res.data.data) || (res && res.data) || {}
        this.$message.success(data.message || '发送成功')
        await this.refreshSendLock()
        this.onLoad(this.page, this.query)
      } catch (e) {
        this.$message.error((e && e.message) || '发送失败')
        await this.refreshSendLock()
      } finally {
        this.sendLoadingId = null
      }
    },
    hasValidSearchDate (searchDate) {
      return Array.isArray(searchDate) && searchDate.length === 2 && searchDate[0] && searchDate[1]
    },
    syncDefaultSearchTime (searchDate) {
      this.defaultParams = {
        ...this.defaultParams,
        startTime: searchDate[0],
        endTime: searchDate[1],
      }
    },
    clearDefaultSearchTime () {
      const defaultParams = { ...this.defaultParams }
      delete defaultParams.startTime
      delete defaultParams.endTime
      this.defaultParams = defaultParams
    },
    normalizeSearchParams (params = {}) {
      const queryParams = { ...params }
      const searchDate = queryParams.searchDate
      if (this.hasValidSearchDate(searchDate)) {
        queryParams.searchDate = searchDate
        this.syncDefaultSearchTime(searchDate)
        return queryParams
      }
      delete queryParams.searchDate
      delete queryParams.startTime
      delete queryParams.endTime
      this.clearDefaultSearchTime()
      return queryParams
    },
    searchChange (params, done) {
      const queryParams = this.normalizeSearchParams(params)
      this.query = queryParams
      this.page.currentPage = 1
      this.selectionClear()
      this.onLoad(this.page, queryParams)
      if (done) done()
    },
    searchReset () {
      const defaultSearchDateRange = getDefaultSearchDateRange()
      this.defaultParams = {
        ...this.defaultParams,
        startTime: defaultSearchDateRange[0],
        endTime: defaultSearchDateRange[1],
      }
      this.query = {
        searchDate: defaultSearchDateRange,
      }
      this.selectionClear()
      this.onLoad(this.page, this.query)
      this.refreshSendLock()
    },
    // 新增
    handleAdd () {
      this.$refs.info.open('新增')
    },
    // 查看详情
    getInfo (row) {
      this.$refs.info.open('查看详情', row)
    },
    //修改
    handleUpdate (row) {
      this.$refs.info.open('修改', row)
    },
    beforeOpen (done, type) {
      // 1.传递交互参数 type id  操作api
      this.transmitData = {
        type,
        id: this.form.id || null,
      }
      this.formTitle = transitionTitle(type)
      this.formVisible = true
    },
    handleClose (type) {
      this.formVisible = false
      // 保存并关闭后刷新列表
      if (type) {
        this.onLoad(this.page, this.query)
        this.refreshSendLock()
      }
    },
    async handleImport () {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xlsx,.xls'
      input.onchange = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        const fileName = file.name || ''
        const lowerName = fileName.toLowerCase()
        if (!lowerName.endsWith('.xls') && !lowerName.endsWith('.xlsx')) {
          this.$message.error('仅支持上传 xls、xlsx 格式文件')
          return
        }
        try {
          await importExcel(file)
          this.$message.success('导入成功')
          this.onLoad(this.page, this.query)
        } catch (error) {
          this.$message.error('导入失败：' + (error.message || '未知错误'))
        }
      }
      input.click()
    },
    async handleDownloadImportTemplate () {
      this.templateLoading = true
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, '列车计划模板.xlsx')
        this.$message.success('模版下载成功')
      } catch (e) {
        this.$message.error((e && e.message) || '模版下载失败')
      } finally {
        this.templateLoading = false
      }
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const queryParams = this.normalizeSearchParams(this.query)
        const params = this.formatParams(Object.assign({}, this.defaultParams, queryParams))
        const res = await exportExcel(params)
        downloadXls(res.data, `车皮调度计划_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
